module.exports = __webpack_public_path__ + "img/success.672048b5.jpg";